var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.indexPageItems),function(item,i){return _c('menu-tile',{key:i,attrs:{"menuItem":item,"focus":i === 0}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }